<template>
  <div>
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <base-header class="pb-6">
      <div class="row align-items-center py-0"></div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <h3 class="mb-0">Courses</h3>
            <p class="text-sm mb-0">The list of courses.</p>
          </template>
          <div>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div>
                <base-button type="primary" @click.prevent="onNew">
                  <span class="btn-inner--icon">
                    <i class="ni e-add"></i>
                  </span>New course
                </base-button>
                <base-button type="info" @click.prevent="onRefresh" icon>
              <span class="btn-inner--icon">
                <i class="ni refresh-02"></i>
              </span>Refresh
            </base-button>
              </div>
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                ></base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
            >
              <!-- <el-table-column v-for="column in tableColumns" :key="column.label" v-bind="column"></el-table-column> -->

              <el-table-column>
                <div slot-scope="{row}">
                  <div class="row">
                    <div class="col-lg-2">
                      <h5>Course code</h5>
                    </div>
                    <div class="col-lg-3">{{row.code}}</div>
                    <div class="col-lg-2">
                      <h5>Title</h5>
                    </div>
                    <div class="col-lg-5">{{row.title}}</div>
                    <div class="col-lg-2">
                      <h5>Description</h5>
                    </div>
                    <div class="col-lg-10">
                      <span v-html="htmldescription(row.description)" />
                    </div>
                    <div class="col-lg-2">
                      <h5>Duration</h5>
                    </div>
                    <div class="col-lg-4">{{row.duration}} week(s)</div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column width="120px" label="Active" prop="status" sortable align="center">
                <template v-slot="{row}">
                  <div class="d-flex justify-content-center">
                    <base-switch v-model="row.status" type="success" :readonly="true"></base-switch>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="140px">
                <div slot-scope="{$index, row}" class="d-flex">
                  <base-button
                    @click.native="onEdit($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni n-edit"></i>
                  </base-button>
                  <base-button
                    @click.native="onDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni e-remove"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "@/components";
import courseTableMixin from "./courseTableMixin";
import { nophoto } from "../../../services/user";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ShowLink, HtmlNewLine } from "../../../services/helper";
export default {
  mixins: [courseTableMixin],
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Loading,
  },
  computed: {},
  props: {
    filter: String,
  },
  data() {
    return {
      tableData: [],
      isLoading: false,
      datafilter: this.filter,
    };
  },
  methods: {
    htmldescription(value) {
      return ShowLink(HtmlNewLine(value));
    },
    onNew() {
      this.$router
        .push({ path: "/course/" + this.currfilter, params: { id: "" } })
        .catch((e) => {});
    },
    onEdit(index, row) {
      this.$router
        .push({ path: "/course/" + this.currfilter + "/" + row.id })
        .catch((e) => {});
    },
    onDelete(index, row) {
      swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.deleteRow(row);
          }
        });
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
